module.exports = __webpack_public_path__ + "static/img/feature_1.0b983e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/feature_1.png
// module id = OTbx
// module chunks = 0